var _circle, _circle2, _path, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSelfTest = function SvgSelfTest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.3804,
    r: 20,
    fill: "#463900"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.3804,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8848 20.2949C49.4834 21.4782 50.8995 22.8937 52.083 24.4922L40.1973 36.3799L52.083 48.2666C50.8995 49.8654 49.4837 51.2814 47.8848 52.4648L35.998 40.5791L24.1113 52.4648C22.5126 51.2813 21.0975 49.8645 19.9141 48.2656L31.7998 36.3799L19.9141 24.4941C21.0975 22.8953 22.5126 21.4784 24.1113 20.2949L35.998 32.1816L47.8848 20.2949Z",
    fill: "#F9BA15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.3804,
    r: 20,
    stroke: "#BDBDBD",
    strokeWidth: 2.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSelfTest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "self-test.898f0f5975078190a17760037a28353b.svg";